import { observer } from 'mobx-react-lite'
import { type BillingMethod } from '@/features/billing/profile/BillingMethod'
import { BillingMethodListItem } from '@/features/billing/components/BillingMethodList'
import { mapBillingMethodToDisplayData } from '@/features/billing/payment-methods/billing-method-display'

export interface BillingMethodSummaryContainerProps {
  billingMethod: BillingMethod
  isDisabled?: boolean
  testId?: string
}

/**
 * Shows a billing method without any actions on it.
 */
export const BillingMethodSummaryContainer = observer(
  function BillingMethodSummaryContainer({
    billingMethod,
    isDisabled,
    testId,
  }: BillingMethodSummaryContainerProps) {
    return (
      <BillingMethodListItem
        billingMethod={mapBillingMethodToDisplayData(billingMethod)}
        isDisabled={isDisabled}
        readOnly
        testId={testId}
      />
    )
  },
)
